import { call, put, all, takeEvery, delay } from "redux-saga/effects";
import {
  FETCH_COMPONENT_SETTING
} from "./actionTypes"
import {
  fetchComponentSettingSuccess
} from "./actions";

import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { USER_MS_EXT } from "../../helpers/url_helper";

function* checkComponentSetting() {
  try {
    // check index.html
    if (localStorage.getItem('component_setting'))
      yield all([
        put(fetchComponentSettingSuccess({ response: JSON.parse(localStorage.getItem('component_setting')) }))
      ]);
    else {
      yield delay(50);
      yield call(checkComponentSetting);
    }
  } catch (error) {
    showMessage(error);
    // alert
  }
}

function* fetchComponentSetting() {
  try {
    // check index.html
    yield call(checkComponentSetting);

    //   const response = yield call(
    //     makeAjax,
    //     url.USER_API.getComponentSetting,
    //     {},
    //     USER_MS_EXT
    //   );
    //   if (response.status == 'SUCCESS') {
    //     yield all([
    //       put(fetchComponentSettingSuccess({ response: response.data }))
    //     ]);
    //   }
    //   else {
    //     showMessage(response);
    //   }
  } catch (error) {
    showMessage(error);

    // alert
  }
}

function* componenetSettingListListSaga() {
  yield takeEvery(FETCH_COMPONENT_SETTING, fetchComponentSetting);
}

export default componenetSettingListListSaga;